<template>
  <div class="solution-header">
    <div class="blue-banner">
      <h1>解决方案</h1>
      <p class="subtitle">打造专业、高效、安全的解决方案</p>
    </div>
  </div>
  <div class="solutions-container">
    <div
        v-for="(solution, index) in solutions"
        :key="index"
        class="solution-item"
        :class="{ 'reverse': index % 2 !== 0 }"
        ref="solutionItems"
    >
      <div class="text-content">
        <h2 class="solution-title">
          <span class="title-icon">🔹</span>
          {{ solution.name }}
        </h2>
        <div class="additional-description" v-if="solution.additionalText">
          <p>{{ solution.text }}</p>
        </div>
        <button
            class="learn-more-btn"
            @click="goToProductDetail(solution.id)"
        >
          了解更多
        </button>
      </div>
      <div class="image-content">
        <img :src="solution.imgUrl" class="solution-image">
      </div>
    </div>
  </div>
</template>

<script>
import server from "@/api/server"
export default {
  computed: {
    SolutionsContent() {
      return SolutionsContent
    }
  },
  data() {
    return {
      solutions: [],
      observer: null
    };
  },
  methods: {
    splitDescription(text) {
      const words = text.split(' ');
      const midPoint = Math.ceil(words.length / 2);
      return [
        words.slice(0, midPoint).join(' '),
        words.slice(midPoint).join(' ')
      ];
    },
    initIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-visible');
            this.observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1
      });

      this.$nextTick(() => {
        if (this.$refs.solutionItems) {
          this.$refs.solutionItems.forEach(item => {
            this.observer.observe(item);
          });
        }
      });
    },
    navigateToSolution(solution) {
      // 使用路由跳转并携带解决方案数据
      this.$router.push({
        path: '/solution-detail',
        query: {
          id: solution.id,
          name: encodeURIComponent(solution.name),
          imgUrl: encodeURIComponent(solution.imgUrl),
          text: encodeURIComponent(solution.text)
        }
      });
    },
    goToProductDetail(id) {
      this.$router.push({
        path: 'SolutionDetails',
        query: {
          id: id
        }
      });
    }
  },

  created() {
    server.Solutions().then(res => {
      this.solutions = res.data.data.map(item => ({
        ...item,
        additionalText: "我们提供全面的技术支持和定制化服务，满足您的各种需求"
      }));
      this.$nextTick(() => {
        this.initIntersectionObserver();
      });
    });
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
/* 原有样式保持不变，只添加按钮的间距样式 */
.text-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.learn-more-btn {
  margin-top: 20px;
  align-self: flex-start; /* 让按钮左对齐 */
}

/* 其余样式保持不变 */
.solutions-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.solution-item {
  display: flex;
  align-items: center;
  margin-bottom: 60px;
  gap: 40px;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease-out;
}

.solution-item.animate-visible {
  opacity: 1;
  transform: translateY(0);
}

.reverse {
  flex-direction: row-reverse;
}

.text-content {
  flex: 1;
  padding: 20px;
}

.image-content {
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.solution-image {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

.solution-image:hover {
  transform: scale(1.03);
}

.solution-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
  position: relative;
  padding-left: 15px;
}

.title-icon {
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
}

.solution-description {
  margin-bottom: 25px;
  line-height: 1.8;
  color: #666;
}

.additional-description {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-left: 4px solid #409EFF;
  border-radius: 4px;
}

.additional-description p {
  color: #555;
  font-style: italic;
  line-height: 1.6;
}

.description-line {
  margin-bottom: 12px;
  position: relative;
  padding-left: 20px;
}

.description-line::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #409EFF;
  font-weight: bold;
}

.learn-more-btn {
  background-color: #409EFF;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
}

.learn-more-btn:hover {
  background-color: #337ecc;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
}

/* 蓝色背景 */
.blue-banner {
  background: linear-gradient(135deg, #c6d6ea, #82bdeb);
  color: white;
  padding: 120px 0;
  text-align: center;
  width: 100%;
  animation: fadeIn 1s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.blue-banner h1 {
  font-size: 2.8rem;
  margin-bottom: 20px;
  font-weight: 600;
}

.subtitle {
  font-size: 1.5rem;
  opacity: 0.9;
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .solution-item {
    gap: 30px;
  }

  .solution-title {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .solutions-container {
    padding: 20px 15px;
  }

  .blue-banner {
    padding: 80px 0;
  }

  .blue-banner h1 {
    font-size: 2.2rem;
  }

  .subtitle {
    font-size: 1.2rem;
  }

  .solution-item,
  .reverse {
    flex-direction: column;
    margin-bottom: 40px;
    gap: 20px;
  }

  .text-content,
  .image-content {
    width: 100%;
    padding: 0;
  }

  .solution-title {
    font-size: 22px;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .learn-more-btn {
    width: 100%;
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .blue-banner h1 {
    font-size: 1.8rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .solution-title {
    font-size: 20px;
  }
}
</style>
